import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import { useState } from 'react';

import { VariabilityGraphLegenda } from '@/pages/ReportV2/components/CustomGraphComponents';
import { FunctionalMovementVariabilityGraph } from '@/pages/ReportV2/components/Graphs';
import { VariabilityModalContent } from '@/pages/ReportV2/components/Modals';
import styles from '@/pages/ReportV2/Styles/Reports.module.css';

import { Card } from '@/components/Cards';
import { ReportModal } from '@/components/Modal/ReportModal';

import { SquatVariabilityData } from '@/models/reportV2.model';

type SquatsHipVariabilityReportProps = {
  tabData: SquatVariabilityData;
};

/** The Walk analysis report tab
 * @param report - The full walk report info and data
 */
export const SquatsVariabilityReportTab = ({ tabData }: SquatsHipVariabilityReportProps) => {
  const [showMoreInfoModal, setShowMoreInfoModal] = useState({
    show: false,
    joint: '',
  });

  if (!tabData) {
    return <IonText>Data not found.</IonText>;
  }
  return (
    <>
      <ReportModal
        isOpen={showMoreInfoModal.show}
        onDidDismiss={() => setShowMoreInfoModal({ show: false, joint: '' })}
        setShowInfo={() => setShowMoreInfoModal({ show: false, joint: '' })}>
        <IonGrid className='' fixed style={{ height: '100%' }}>
          {showMoreInfoModal.joint === 'Hip' && (
            <VariabilityModalContent
              coordinativeVariabilityData_Left={tabData.coordinativeVariabilitySeriesHip_Left}
              coordinativeVariabilityData_Right={tabData.coordinativeVariabilitySeriesHip_Right}
              crp_Left={tabData.crpSeriesPelvisThigh_Left}
              crp_Right={tabData.crpSeriesPelvisThigh_Right}
              setShowMoreInfoModal={setShowMoreInfoModal}
            />
          )}
          {showMoreInfoModal.joint === 'Knee' && (
            <VariabilityModalContent
              coordinativeVariabilityData_Left={tabData.coordinativeVariabilitySeriesKnee_Left}
              coordinativeVariabilityData_Right={tabData.coordinativeVariabilitySeriesKnee_Right}
              crp_Left={tabData.crpSeriesThighCalf_Left}
              crp_Right={tabData.crpSeriesThighCalf_Right}
              setShowMoreInfoModal={setShowMoreInfoModal}
            />
          )}
          {showMoreInfoModal.joint === 'Ankle' && (
            <VariabilityModalContent
              coordinativeVariabilityData_Left={tabData.coordinativeVariabilitySeriesAnkle_Left}
              coordinativeVariabilityData_Right={tabData.coordinativeVariabilitySeriesAnkle_Right}
              crp_Left={tabData.crpSeriesCalfFoot_Left}
              crp_Right={tabData.crpSeriesCalfFoot_Right}
              setShowMoreInfoModal={setShowMoreInfoModal}
            />
          )}
        </IonGrid>
      </ReportModal>

      <IonRow className={styles.variabilityRow}>
        <IonCol className='ion-align-self-stretch' size='12'>
          <Card
            onClick={() => setShowMoreInfoModal({ show: true, joint: 'Hip' })}
            style={{ height: 'fit-content', margin: 0 }}>
            <IonRow
              className='ion-no-padding ion-align-items-center ion-justify-content-evenly'
              style={{ height: '100%' }}>
              <IonCol className='ion-align-self-stretch' size='2'>
                <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '25%' }}>
                  <IonCol className='ion-no-padding ' size='12'>
                    <p className={styles.variabilityTitle}>Hip</p>
                  </IonCol>
                </IonRow>
                <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '75%' }}>
                  <VariabilityGraphLegenda legend={tabData.pelvisLegend} />
                </IonRow>
              </IonCol>
              <IonCol className='ion-no-padding ion-align-items-center ion-align-self-stretch' size='5'>
                <FunctionalMovementVariabilityGraph
                  coordinativeVariabilityData={tabData.coordinativeVariabilityOverviewHip_Left}
                  crpData={tabData.crpSeriesPelvisThigh_Left}
                />
              </IonCol>
              <IonCol className='ion-no-padding ion-align-self-stretch' size='5'>
                <FunctionalMovementVariabilityGraph
                  coordinativeVariabilityData={tabData.coordinativeVariabilityOverviewHip_Right}
                  crpData={tabData.crpSeriesPelvisThigh_Right}
                />
              </IonCol>
            </IonRow>
          </Card>
        </IonCol>
      </IonRow>
      <IonRow className={styles.variabilityRow}>
        <IonCol className='ion-align-self-stretch' size='12'>
          <Card
            onClick={() => setShowMoreInfoModal({ show: true, joint: 'Knee' })}
            style={{ height: 'fit-content', margin: 0 }}>
            <IonRow
              className='ion-no-padding ion-align-items-center ion-justify-content-evenly'
              style={{ height: '100%' }}>
              <IonCol className='ion-align-self-stretch' size='2'>
                <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '25%' }}>
                  <IonCol className='ion-no-padding' size='12'>
                    <p className={styles.variabilityTitle}>Knee</p>
                  </IonCol>
                </IonRow>
                <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '75%' }}>
                  <VariabilityGraphLegenda legend={tabData.kneeLegend} />
                </IonRow>
              </IonCol>
              <IonCol className='ion-no-padding ion-align-items-center ion-align-self-stretch' size='5'>
                <FunctionalMovementVariabilityGraph
                  coordinativeVariabilityData={tabData.coordinativeVariabilityOverviewKnee_Left}
                  crpData={tabData.crpSeriesThighCalf_Left}
                />
              </IonCol>
              <IonCol className='ion-no-padding' size='5'>
                <FunctionalMovementVariabilityGraph
                  coordinativeVariabilityData={tabData.coordinativeVariabilityOverviewKnee_Right}
                  crpData={tabData.crpSeriesThighCalf_Right}
                />
              </IonCol>
            </IonRow>
          </Card>
        </IonCol>
      </IonRow>
      <IonRow className={styles.variabilityRow}>
        <IonCol className='ion-align-self-stretch' size='12'>
          <Card
            onClick={() => setShowMoreInfoModal({ show: true, joint: 'Ankle' })}
            style={{ height: 'fit-content', margin: 0 }}>
            <IonRow
              className='ion-no-padding ion-align-items-center ion-justify-content-evenly'
              style={{ height: '100%' }}>
              <IonCol className='ion-align-self-stretch' size='2'>
                <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '25%' }}>
                  <IonCol className='ion-no-padding' size='12'>
                    <p className={styles.variabilityTitle}>Ankle</p>
                  </IonCol>
                </IonRow>
                <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '50%' }}>
                  <VariabilityGraphLegenda legend={tabData.ankleLegend} />
                </IonRow>
              </IonCol>
              <IonCol className='ion-no-padding ion-align-items-center ion-align-self-stretch' size='5'>
                <FunctionalMovementVariabilityGraph
                  coordinativeVariabilityData={tabData.coordinativeVariabilityOverviewAnkle_Left}
                  crpData={tabData.crpSeriesCalfFoot_Left}
                />
              </IonCol>
              <IonCol className='ion-no-padding' size='5'>
                <FunctionalMovementVariabilityGraph
                  coordinativeVariabilityData={tabData.coordinativeVariabilityOverviewAnkle_Right}
                  crpData={tabData.crpSeriesCalfFoot_Right}
                />
              </IonCol>
            </IonRow>
          </Card>
        </IonCol>
      </IonRow>
    </>
  );
};
